/* BRAZILINA : toggle "À plat | Porté" sur les cartes de la PAGE COLLECTION uniquement (mobile) */
(function () {
  function isCollection() { return document.body && document.body.classList.contains('template-collection'); }
  function isMobile() { return window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches; }
  function viewLabels() {
    var p = (location.pathname || '').toLowerCase();
    if (p.indexOf('culotte') !== -1) return ['De face', 'De dos'];
    if (p.indexOf('t-shirt-bresil') !== -1) return ['Vue 1', 'Vue 2'];
    if (p.indexOf('casquette') !== -1) return ['Modèle 1', 'Modèle 2'];
    if (p.indexOf('top-bresil') !== -1) return ['Modèle 1', 'Modèle 2'];
    if (p.indexOf('maillot-de-bain') !== -1 || p.indexOf('bikini') !== -1) return ['Vue 1', 'Vue 2'];
    return ['À plat', 'Porté'];
  }
  function directChild(el, tag) {
    for (var i = 0; i < el.children.length; i++) if (el.children[i].tagName === tag) return el.children[i];
    return null;
  }
  function directChildren(el, tag) {
    var out = [];
    for (var i = 0; i < el.children.length; i++) if (el.children[i].tagName === tag) out.push(el.children[i]);
    return out;
  }
  function initOne(fig) {
    if (fig.dataset.brzInit) return;
    var a = directChild(fig, 'A'); if (!a) return;
    var pics = directChildren(a, 'PICTURE'); if (pics.length < 2) return;
    fig.dataset.brzInit = '1';

    var tog = document.createElement('div');
    tog.className = 'brz-view-toggle';
    var L = viewLabels();
    tog.innerHTML = '<span class="brz-seg brz-seg-flat on" role="button" tabindex="0">' + L[0] + '</span>'
                  + '<span class="brz-seg brz-seg-worn" role="button" tabindex="0">' + L[1] + '</span>';
    var segFlat = tog.querySelector('.brz-seg-flat');
    var segWorn = tog.querySelector('.brz-seg-worn');
    function goTo(idx, e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      a.scrollTo({ left: idx * a.clientWidth, behavior: 'smooth' });
    }
    segFlat.addEventListener('click', function (e) { goTo(0, e); });
    segWorn.addEventListener('click', function (e) { goTo(1, e); });
    fig.appendChild(tog);

    var raf = null;
    a.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var idx = Math.round(a.scrollLeft / Math.max(1, a.clientWidth));
        segFlat.classList.toggle('on', idx === 0);
        segWorn.classList.toggle('on', idx !== 0);
      });
    }, { passive: true });
  }
  function initAll() {
    if (!isCollection() || !isMobile()) return;
    var figs = document.querySelectorAll('.l4cl li.second-img-hover:not(.second-img-first) > figure');
    for (var i = 0; i < figs.length; i++) initOne(figs[i]);
  }
  var deb = null;
  function initDebounced() { clearTimeout(deb); deb = setTimeout(initAll, 150); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initDebounced);
  if (window.MutationObserver && isCollection()) {
    var host = document.querySelector('#main-collection, .shopify-section-collection, main') || document.body;
    new MutationObserver(initDebounced).observe(host, { childList: true, subtree: true });
  }
})();
